import React, { ReactNode } from 'react'

interface CustomLabelProps {
  possuiErro?: boolean;
  children: ReactNode;
  className?: string; 
}

export const CustomLabel: React.FC<CustomLabelProps> = ({ possuiErro, children, className }) => {
  return (
    <label className={`label-input ${possuiErro ? 'error-input-gc' : ''} ${className || ''}`}>
      {children}
    </label>
  )
}

